import { CIMSTabs } from 'components/CIMSTabs'
import Queue from './components/Queue'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import Request from './components/Request'

const BatchReports: React.FC = () => {
  const BatchReportsTab = {
    BatchRequest: 'Batch Request',
    Queue: 'Queue',
  } as const
  return (
    <PayItemSelectProvider>
      <CIMSTabs
        initialTab={BatchReportsTab.Queue}
        tabs={[
          {
            key: BatchReportsTab.Queue,
            label: BatchReportsTab.Queue,
            component: <Queue />,
          },
          {
            key: BatchReportsTab.BatchRequest,
            label: BatchReportsTab.BatchRequest,
            component: <Request />,
          },
        ]}
      />
    </PayItemSelectProvider>
  )
}

export default BatchReports
